import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';
import { Skeleton } from '@material-ui/lab';
import useAuth from 'src/hooks/api/useAuth';

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    padding: 20,
    flex: '0 0 33.33%',
    alignItems: 'center',
    flexDirection: 'column',
  },
  numberContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  pending: {
    fontSize: 20,
  },
  icon: {
    color: '#98a6ad !important',
    height: 30,
    marginBottom: 10,
  },
  danger: {
    color: '#fa5c7c',
    fontWeight: 'bold',
  },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  userId: number;
  endpoint: string;
  icon: string;
  title: string;
}

const Stats: React.FC<Props> = (props) => {
  const { className, endpoint, icon, title, userId, ...otherProps } = props;

  const { entities, loading } = useStats(endpoint, userId);

  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...otherProps}>
      <img className={classes.icon} src={icon} alt='Icône' />

      {loading ? (
        <Skeleton width={20} />
      ) : (
        <div className={classes.numberContainer}>
          <div className={classes.pending}>{entities?.pending || 0}</div>
          <div>
            (<span className={classes.danger}>{entities?.expired || 0}</span>)
          </div>
        </div>
      )}

      <div className='title-container'>{title}</div>
    </div>
  );
};

const defaultStats = {
  pending: 0,
  expired: 0,
};

const useStats = (endpoint: string, userId: number) => {
  const [entities, setEntities] = useState(defaultStats);
  const [loading, setLoading] = useState(false);
  const { fetch } = useAuth();

  const fetchStats = () => {
    setLoading(true);
    return fetch(`${endpoint}?userId=${userId}`, {
      method: 'GET',
    })
      .then((resp) => {
        setLoading(false);
        return resp.json();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const refresh = () => {
    fetchStats().then((stats) => {
      setEntities(stats);
    });
  };

  useEffect(() => {
    refresh();
  }, [endpoint, userId]);

  return {
    entities,
    loading,
    refresh,
  };
};

export default Stats;
